/** SOP Class UIDs de Radiation Dose SR */
export const RDSR_SOP_CLASS = '1.2.840.10008.5.1.4.1.1.88.67'
export const RRDSR_SOP_CLASS = '1.2.840.10008.5.1.4.1.1.88.68'

/**
 * @param {string|null|undefined} sopClassUID
 * @returns {boolean}
 */
export function isRdsrSopClass(sopClassUID) {
  const u = String(sopClassUID || '').trim()
  return u === RDSR_SOP_CLASS || u === RRDSR_SOP_CLASS
}

/**
 * @param {object|null} fileItem
 * @returns {boolean}
 */
export function isRdsrFileItem(fileItem) {
  if (!fileItem) return false
  if (fileItem.series && fileItem.series.isRdsr === true) return true
  const modality = String(
    (fileItem.series && fileItem.series.modality) || fileItem.modality || ''
  ).toUpperCase()
  if (modality === 'SR') {
    // SR genérico: confirmar SOP si hay imagen
  }
  let sop = fileItem.sopClassUID || (fileItem.series && fileItem.series.sopClassUID)
  if (!sop && fileItem.image && fileItem.image.data && typeof fileItem.image.data.string === 'function') {
    try {
      sop = fileItem.image.data.string('x00080016')
    } catch (e) {
      /* ignore */
    }
  }
  return isRdsrSopClass(sop)
}

/**
 * @param {{ seriesList?: Map, seriesKeys?: any[] }|null} seriesStore
 * @returns {{ key: *, files: object[] }|null}
 */
export function findRdsrSeriesInStore(seriesStore) {
  if (!seriesStore || !seriesStore.seriesList) return null
  const keys =
    Array.isArray(seriesStore.seriesKeys) && seriesStore.seriesKeys.length
      ? seriesStore.seriesKeys
      : [...seriesStore.seriesList.keys()]
  for (const key of keys) {
    const files = seriesStore.seriesList.get(key)
    if (!Array.isArray(files) || !files.length) continue
    if (files.some(isRdsrFileItem)) return { key, files }
  }
  return null
}
